var Navigation = function (options) {
  var self = this;

  this.toggle = {
    element: document.body.getElementsByClassName(options.toggle)[0],
    selector: options.toggle,
    active: options.toggle + "--active",
    ariaLabelOpen: options.openText,
    ariaLabelClosed: options.closedText,
  };

  this.nav = {
    element: document.body.getElementsByClassName(options.nav)[0],
    selector: options.nav,
    active: options.nav + "--active",
  };

  this.navItems = document.querySelectorAll(".nav-section__info");

  if (typeof options.subnav !== "undefined") {
    this.subnav = {
      elements: document.body.getElementsByClassName(options.subnav),
      selector: options.subnav,
      active: options.subnav + "--active",
    };
  }

  self.init = function () {
    // Navigation Toggle Button Click event
    $(self.toggle.element).on("click", function () {
      self.toggleNav();
    });

    $("a", self.nav.element)
      .last()
      .on("blur", function () {
        self.closeNav();
      });

    $(document).on("click", function (e) {
      if ($(self.nav.element).hasClass(self.nav.active)) {
        if (
          $(e.target).parents("." + self.nav.selector).length === 0 &&
          !$(e.target).is(self.nav.element) &&
          $(e.target).parents("." + self.toggle.selector).length === 0 &&
          !$(e.target).is(self.toggle.element)
        ) {
          e.preventDefault();
          self.closeNav();
        }
      }
    });

    $(document).on("keyup", function (e) {
      if (e.keyCode == 27) {
        // esc keycode `27`
        self.closeNav();
      }
    });

    // Sub Navigation Link events
    if (typeof self.subnav !== "undefined") {
      $(self.subnav.elements).each(function () {
        var currSubnav = $(this);
        currSubnav.on("click", function () {
          self.toggleSubNav(currSubnav);
        });
        $(".sub-nav-list a", currSubnav).each(function () {
          $(this).on("focus", function () {
            self.openSubNav(currSubnav);
            // console.log('focused');
          });
        });
      });
    }

    // console.info('Navigation:', self.nav.selector);
  };

  self.toggleNav = function () {
    if ($(self.toggle.element).hasClass(self.toggle.active)) {
      $(self.toggle.element).removeClass(self.toggle.active).attr({
        "aria-label": self.toggle.ariaLabelOpen,
        "aria-expanded": "false",
      });
      $(self.nav.element)
        .removeClass(self.nav.active)
        .attr("aria-expanded", "false");
      this.navItems.forEach((item) => (item.href = "#"));
    } else {
      if (!window.navigator.userAgent.toLowerCase().includes("mobile")) {
        this.navItems[0].href = "/menu";
        this.navItems[1].href = "/hooters-girls";
        this.navItems[2].href = "https://shop.hooters.com";
        this.navItems[3].href = "/about/history";
      }
      $(self.toggle.element).addClass(self.toggle.active).attr({
        "aria-label": self.toggle.ariaLabelClosed,
        "aria-expanded": "true",
      });
      $(self.nav.element)
        .addClass(self.nav.active)
        .attr("aria-expanded", "true");
      $(self.nav.element).focus();
    }

    if (typeof self.subnav != "undefined") {
      $(self.subnav.elements).removeClass(self.subnav.active);
    }
  };

  if (typeof self.subnav !== "undefined") {
    self.openSubNav = function (currSubnav) {
      $(self.subnav.elements).not(currSubnav).removeClass(self.subnav.active);
      $(currSubnav).addClass(self.subnav.active);
    };

    self.closeSubNav = function (currSubnav) {
      $(currSubnav).removeClass(self.subnav.active);
    };

    self.toggleSubNav = function (currSubnav) {
      $(self.subnav.elements).not(currSubnav).removeClass(self.subnav.active);
      $(currSubnav).toggleClass(self.subnav.active);
    };
  }
};
